import { render, staticRenderFns } from "./TestInstances.vue?vue&type=template&id=01320e3c&scoped=true&"
import script from "./TestInstances.vue?vue&type=script&lang=ts&"
export * from "./TestInstances.vue?vue&type=script&lang=ts&"
import style0 from "./TestInstances.vue?vue&type=style&index=0&id=01320e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01320e3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VDataTable,VToolbar,VToolbarTitle})
